/**
 * @prettier
 * @flow
 */
import * as React from 'react';
import { FormSelect } from 'src/components/form/FormSelect';
import type { Variant } from 'src/components/form/FormTypes';
import { translate } from 'src/utils/translate/translate';

export function FormInstructionSelect({ name, label, placeholder, helperText, defaultValue, disabled, required, variant = 'outlined', version1 }: Props) {
    if (version1) {
        var options = required
            ? Object.values(InstructionV1).map((city: any) => ({ label: translate(city), value: city }))
            : [{ label: '', value: null }, ...Object.values(InstructionV1).map((city: any) => ({ label: translate(city), value: city }))];
    } else {
        var options = required
            ? Object.values(Instruction).map((city: any) => ({ label: translate(city), value: city }))
            : [{ label: '', value: null }, ...Object.values(Instruction).map((city: any) => ({ label: translate(city), value: city }))];
    }
    return (
        <FormSelect
            name={name}
            label={label}
            placeholder={placeholder}
            helperText={helperText}
            defaultValue={defaultValue}
            options={options}
            disabled={disabled}
            required={required}
            variant={variant}
        />
    );
}

type Props = {|
    name: string,
    label?: string,
    placeholder?: string,
    helperText?: string,
    defaultValue?: string,
    disabled?: boolean,
    required?: boolean | { value: number, message: string },
    variant?: Variant,
    version1?: boolean,
|};

const InstructionV1 = Object.freeze({
    PAYMENT: 'PAYMENT',
    CANCEL_PAYMENT: 'CANCEL_PAYMENT',
    REFUND_PAYMENT: 'REFUND_PAYMENT',
});

const Instruction = Object.freeze({
    PAYMENT: 'PAYMENT',
    CANCEL_PAYMENT: 'CANCEL_PAYMENT',
    REFUND_PAYMENT: 'REFUND_PAYMENT',
    ABORT_PAYMENT_PROCESS: 'ABORT_PAYMENT_PROCESS',
    PRINT: 'PRINT',
    // SET_TERMINAL_SETTINGS: 'SET_TERMINAL_SETTINGS',
});

